module.exports = __webpack_public_path__ + "img/326-95bb7e.png";